import React from 'react'
import { withValueField } from './ValueField'
import { priceFormat } from '../../services/currency'

export default withValueField(({ value }) => <span>{priceFormat(value)}</span>)
